var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Button/Button.tsx
import { cloneElement, forwardRef, useRef } from "react";
import { cva, cx } from "class-variance-authority";
import { combineRefs } from "@bice_vida/ds-react-utils";
import "@bice_vida/ds-styles-button";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var buttonStyles = cva("btn", {
  variants: {
    variant: {
      primary: "btn-primary",
      secondary: "btn-secondary",
      link: "btn-link"
    },
    size: {
      s: "btn-s",
      m: "btn-m",
      l: "btn-l",
      xl: "btn-xl"
    },
    colorScheme: {
      primary: "btn-color-primary",
      danger: "btn-color-danger"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "m",
    colorScheme: "primary"
  }
});
var buttonSpinnerStyles = cva("btn-spinner", {
  variants: {
    hasText: {
      true: "btn-spinner-text"
    }
  },
  defaultVariants: {
    hasText: false
  }
});
var Button = forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, {
      loading,
      disabled,
      loadingText,
      leftIcon: originalLeftIcon,
      rightIcon: originalRightIcon,
      children,
      className,
      variant,
      size,
      colorScheme,
      type = "button",
      onClick
    } = _b, props = __objRest(_b, [
      "loading",
      "disabled",
      "loadingText",
      "leftIcon",
      "rightIcon",
      "children",
      "className",
      "variant",
      "size",
      "colorScheme",
      "type",
      "onClick"
    ]);
    const ref = useRef(null);
    const composedRef = combineRefs(forwardedRef, ref);
    const leftIcon = originalLeftIcon ? cloneElement(originalLeftIcon, {
      className: cx(
        originalLeftIcon.props.className,
        "btn-icon btn-icon-left"
      )
    }) : null;
    const rightIcon = originalRightIcon ? cloneElement(originalRightIcon, {
      className: cx(
        originalRightIcon.props.className,
        "btn-icon btn-icon-right"
      )
    }) : null;
    return /* @__PURE__ */ jsxs(
      "button",
      __spreadProps(__spreadValues({
        className: buttonStyles({ variant, size, colorScheme, className }),
        "data-loading": loading,
        disabled: disabled || loading,
        onClick: (e) => {
          if (ref.current && !ref.current.classList.contains("btn-animation")) {
            ref.current.classList.add("btn-animation");
          }
          onClick == null ? void 0 : onClick(e);
        },
        ref: composedRef,
        type
      }, props), {
        children: [
          loading ? /* @__PURE__ */ jsx("div", { className: buttonSpinnerStyles({ hasText: Boolean(loadingText) }) }) : null,
          loading ? loadingText : /* @__PURE__ */ jsxs(Fragment, { children: [
            leftIcon,
            variant === "link" ? /* @__PURE__ */ jsx("span", { children }) : children,
            rightIcon
          ] })
        ]
      })
    );
  }
);
Button.displayName = "Button";
var Button_default = Button;
export {
  Button_default as Button
};
